/**
 * @name AuthenticatedMediaGateway
 * @version 1.0
 * @requires bam, jQuery
 * @description
 * Abstracts the flow from having a content id to
 * getting a secure, authenticated stream url.
 */
define('auth-media-gateway/AuthenticatedMediaGateway',['require','exports','module','auth-media-gateway/serviceClients/mediaService','auth-media-gateway/subclasses/Utils','bam.cookies/cookies','bam.xdomainrequest/bam.xdomainrequest','auth-media-gateway/vo/MediaCatalogResponseVO','auth-media-gateway/vo/MediaItemResponseVO','message-service/message-service','gameday-index-enums/enums/events/OauthEvents','client/client'],function(require, exports, module) {

	var profile = null;
	var MediaService = require('auth-media-gateway/serviceClients/mediaService'),
		Utils = require('auth-media-gateway/subclasses/Utils'),
		cookies = require('bam.cookies/cookies'),
		xdomain = require('bam.xdomainrequest/bam.xdomainrequest'),
		MediaCatalogResponseVO = require('auth-media-gateway/vo/MediaCatalogResponseVO'),
		MediaItemResponseVO = require('auth-media-gateway/vo/MediaItemResponseVO'),
		MessageService = require("message-service/message-service"),
		evts = require("gameday-index-enums/enums/events/OauthEvents");
	//var  LoginDelegate = require('auth-media-gateway/subclasses/LoginDelegate');


	var AuthenticatedMediaGateway = (function() {

		/********* LOGIN / AUTHENTICATION FUNCTIONS *********/
		var
			self = this,
			amg,
			AuthenticatedMediaGateway,
			mediaParams,
			configModel = {},
			_isCatalogRequest = false,


		// session key used by Registration Services to ensure single sign-on restriction
			sessionCookieName = "mssk",
			mediaServiceSessionKey = cookies.get(sessionCookieName);

		//session cookie, if present, and unescape the value
		if (!!mediaServiceSessionKey) {
			mediaServiceSessionKey = unescape(mediaServiceSessionKey);
		}

		function beginLoginAuthFlow() {

			//create a new login delegate, which handles all the service interactions
			//ld = new LoginDelegate(configModel);
			//check if we get a quick login for free
			//var isLoggedIn = ld.isLoggedIn();
			var isLoggedIn = true;
			var isLoginRequired = false;
			Utils.log("AuthenticatedMediaGateway beginLoginAuthFlow: isLoggedIn = " + isLoggedIn + ", isLoginRequired = " + isLoginRequired);

			if (mediaParams.partner_token || !isLoginRequired) {
				//if we do not need to be logged in
				callMediaService();
			} else if (isLoginRequired && !isLoggedIn) {
				//if we're not logged in at all, present the login prompt to authenticate
				presentLoginScreen();
			} else {
				//if we think we're already logged in, verify that the creds are still valid
				verifyLoginStatusInBackground();
			}
		}

		function loginRequired() {
			Utils.log("AuthenticatedMediaGateway loginRequired:");

			var isRequired = true;
			if (!!configModel.bypassLogin) {
				isRequired = false;
			} else if (typeof mediaParams.authorization !== "undefined") {
				isRequired = mediaParams.authorization;
			} else if (typeof mediaParams.login !== "undefined") {
				isRequired = mediaParams.login;
			}

			Utils.log("AuthenticatedMediaGateway loginRequired: return isRequired = " + isRequired);

			return isRequired;
		}

		function verifyLoginStatusInBackground() {
			//Utils.log("AuthenticatedMediaGateway verifyLoginStatusInBackground:");
			//ld.isLoggedIn(handleVerifyLoginStatusResult,true);
			handleLoginSuccess();
		}

		function handleVerifyLoginStatusResult(resultObj) {
			var isLoggedIn = resultObj.isLoggedIn;
			if (typeof resultObj.profile !== 'undefined') {
				profile = resultObj.profile;
			}
			Utils.log("AuthenticatedMediaGateway handleVerifyLoginStatusResult: isLoggedIn = " + isLoggedIn);
			if (!isLoggedIn) {
				presentLoginScreen();
			} else {
				callMediaService();
			}
		}

		function presentLoginScreen() {
			/*Utils.log("AuthenticatedMediaGateway presentLoginScreen:");
			 MessageService.publish(amg.LOGIN_CHALLENGE);
			 ld.bind(LoginDelegate.LOGIN_SUCCESS,handleLoginSuccess);
			 ld.bind(LoginDelegate.LOGIN_ERROR,handleLoginError);
			 ld.display();*/
		}

		function handleLoginSuccess() {
			Utils.log("AuthenticatedMediaGateway handleLoginSuccess:");
			MessageService.publish(evts.LOGIN_SUCCESS);
			callMediaService();

		}

		function handleLoginError() {
			Utils.log("AuthenticatedMediaGateway handleLoginError:");
		}

		function doLogoutInPlace() {
			Utils.log("AuthenticatedMediaGateway doLogoutInPlace:");
		}


		/********* MEDIA SERVICE *********/
		function callMediaService() {
			Utils.log("AuthenticatedMediaGateway callMediaService:");
			//add listeners
			MediaService.one('requestMedia:success', handleMediaRequestSuccess);
			MediaService.one('requestMedia:error', handleMediaRequestError);

			if (!!mediaServiceSessionKey) {
				mediaParams.session_key = unescape(mediaServiceSessionKey);
			}

			MediaService.requestMedia(mediaParams);
		}

		function handleMediaRequestSuccess(evtType, mediaResponse) {
			Utils.log("AuthenticatedMediaGateway handleMediaRequestSuccess:");

			if (_isCatalogRequest) {
				handleCatalogRequestSuccess(evtType, mediaResponse);
			} else {
				handlePlaybackUrlRequestSuccess(evtType, mediaResponse);
			}
		}

		function handleCatalogRequestSuccess(evtType, mediaResponse) {

			Utils.log("AuthenticatedMediaGateway handleCatalogRequestSuccess:");

			var mediaCatalogResponseVO;
			try {
				mediaCatalogResponseVO = new MediaCatalogResponseVO(mediaResponse, profile);
			} catch(e) {
				//if there was an error parsing the response, trigger an error event and return;
				Utils.log("AuthenticatedMediaGateway handleCatalogRequestSuccess: there was an error parsing the response, so trigger an error event and return");
				MessageService.publish(evts.MEDIA_CATALOG_ERROR, mediaResponse);
				return;
			}

			// just started a session? let's store the key from the response in our cookie
			setSessionKeyCookie(mediaResponse);

			if (mediaCatalogResponseVO.isLoginRequired) {
				//All content items require login to proceed
				// MessageService.publish(amg.LOGIN_CHALLENGE);
				presentLoginScreen();
			} else if (!mediaCatalogResponseVO.isAuthorized) {
				//The user account is not authorized to play this content
				MessageService.publish(evts.MEDIA_CATALOG_NOT_AUTHORIZED, mediaCatalogResponseVO);
			} else {
				// TODO Add more conditions around what event to dispatch

				//The media catalog has playable content
				MessageService.publish(evts.MEDIA_CATALOG_SUCCESS, mediaCatalogResponseVO);
			}
		}

		function handlePlaybackUrlRequestSuccess(evtType, mediaResponse) {

			Utils.log("AuthenticatedMediaGateway handlePlaybackUrlRequestSuccess:");

			var mediaItemResponseVO;
			try {
				mediaItemResponseVO = new MediaItemResponseVO(mediaResponse);
			} catch(e) {
				//if there was an error parsing the response, trigger an error event and return;
				MessageService.publish(evts.MEDIA_ITEM_ERROR, mediaResponse);
				return;
			}


			setMediaFrameworkSessionCookies(mediaItemResponseVO);

			// just started a session? let's store the key from the response in our cookie
			setSessionKeyCookie(mediaResponse);

			if (mediaItemResponseVO.isLoginRequired) {
				//The media item requires login to proceed
				//MessageService.publish(evts.LOGIN_CHALLENGE);
				presentLoginScreen();
			} else if (!!mediaItemResponseVO.isAuthorized && !!mediaItemResponseVO.isNotBlackedOut) {
				//The media item is playable
				MessageService.publish(evts.MEDIA_ITEM_PLAYABLE, mediaItemResponseVO);
			} else if (!mediaItemResponseVO.isAuthorized) {
				//The user account is not authorized to play this content
				MessageService.publish(evts.MEDIA_ITEM_NOT_AUTHORIZED, mediaItemResponseVO);
			} else if (!mediaItemResponseVO.isNotBlackedOut) {
				//The user is blacked out
				MessageService.publish(evts.MEDIA_ITEM_BLACKOUT, mediaItemResponseVO);
			} else {
				//something went wrong - we should never get here
				MessageService.publish(evts.MEDIA_ITEM_ERROR, mediaItemResponseVO);
			}
		}

		function setSessionKeyCookie(mediaResponse) {
			// just started a session? let's store the key from the response in our cookie
			if (!!mediaResponse.session_key) {

				mediaServiceSessionKey = mediaResponse.session_key;
				cookies.set({
					name: sessionCookieName,
					value: mediaServiceSessionKey,
					path: '/',
					expires: new Date(new Date().getTime() + (60 * 60 * 1000))
				});
			}
		}

		function setMediaFrameworkSessionCookies(mediaItemResponseVO) {
			var client = require("client/client");
			var SET_MEDIA_FRAMEWORK_BROWSER_COOKIES = client.isChrome;

			if (SET_MEDIA_FRAMEWORK_BROWSER_COOKIES === true) {
				try {
					// Grab mediaAuth cookie value(s) if present (should only apply to HLS playback scenarios)
					var mediaFrameworkSessionCookies = mediaItemResponseVO.mfCookies;

					// commit the cookie values from the response as browser cookies (just in case the browser doesn't set the cookies)
					if (!!mediaFrameworkSessionCookies && mediaFrameworkSessionCookies.length > 0) {
						var sessionCookie;
						var hParts = window.location.hostname.split('.');
						var domainToUse = '.' + hParts[hParts.length - 2] + '.' + hParts[hParts.length - 1];

						for (i in mediaFrameworkSessionCookies) {
							sessionCookie = mediaFrameworkSessionCookies[i];
							if (!!sessionCookie) {
								cookies.set({
									name: sessionCookie.name,
									value: sessionCookie.value,
									domain: domainToUse,  // ex: '.wwe.com'
									path: '/'
								});
							}
						}
					}
				} catch(error) {
					Utils.log("AuthenticatedMediaGateway setMediaFrameworkSessionCookies: error grabbing cookie values from the mediaItemResponseVO");
				}
			}
		}

		function handleMediaRequestError(evtType, evtArgs) {
			Utils.log("AuthenticatedMediaGateway handleMediaRequestError:");

			// Prompt user to login if Invalid User Credentials encountered
			if (evtArgs.code === "-3000") {
				// presentLoginScreen();
				return;
			}

			// clear session key on any error
			mediaServiceSessionKey = null;
			cookies.remove({
				name: sessionCookieName,
				path: '/'
			});

			MessageService.publish(evts.MEDIA_ITEM_ERROR, evtArgs);
		}

		// START - INTERFACE FOR THE SINGLETON INSTANCE
		amg = AuthenticatedMediaGateway = {
			requestMedia: function(authenticatedMediaParams) {
				_isCatalogRequest = false;
				mediaParams = authenticatedMediaParams;
				mediaParams.frameworkURL = configModel.frameworkURL;
				mediaParams.frameworkEndPoint = configModel.frameworkEndPoint;
				beginLoginAuthFlow();
			},

			requestMediaCatalog: function(authenticatedMediaParams) {
				_isCatalogRequest = true;
				mediaParams = authenticatedMediaParams;
				mediaParams.frameworkURL = configModel.frameworkURL;
				mediaParams.frameworkEndPoint = configModel.frameworkEndPoint;

				// TODO This should not require login as some content will not require login but we won't know that until we get the catalog back
				beginLoginAuthFlow();
			},

			/**
			 * @function configure
			 * @param authenticatedMediaGatewayConfig Object
			 */
			configure: function(authenticatedMediaGatewayConfig) {
				configModel = authenticatedMediaGatewayConfig;
			}
		};
		// END - SINGLETON INTERFACE

		return AuthenticatedMediaGateway;
	})();



	return {
		getInstance: function() {
			return AuthenticatedMediaGateway;
		}
	};
})
;
